import { OneClickFromCrmStatus } from './one-click-from-crm-statuses'

export default {
  activateOneClickFromCrm(state, { first_name }) {
    state.oneClickFromCrm = true
    state.actionTakerName = first_name
  },

  applyOneClickFieldMappings(state, crmResponse) {
    if (!state.oneClickFieldMappings) {
      return
    }

    for (const oneClickFieldMapping of state.oneClickFieldMappings) {
      // Lookup the agra field from the one-click field mapping in the list of fields to assign as
      // a regular or an additional field
      const matchingAgraField = state.fields.find((f) => f.name === oneClickFieldMapping.agraFieldName)

      if (!matchingAgraField) {
        console.log(`Could not find matching field with name ${oneClickFieldMapping.agraFieldName}`)
        continue
      }

      // Only assign from CRM if response includes a value. This avoids that additional fields
      // with hideIfSetFromCrm == true are implicitly set to null
      const fieldValueFromCrm = crmResponse[oneClickFieldMapping.crmFieldName]
      if (fieldValueFromCrm) {
        if (matchingAgraField.isAdditionalField) {
          state.action.additionalFields[oneClickFieldMapping.agraFieldName] = fieldValueFromCrm
        } else {
          state.action[oneClickFieldMapping.agraFieldName] = fieldValueFromCrm
        }

        state.fieldsSetFromCrm.push(oneClickFieldMapping.agraFieldName)
      }
    }
  },

  cancelOneClick(state) {
    if (state.tryOneClickFromCrm) {
      state.oneClickFromCrm = false
      state.extraParams.fill_from_crm = false
      state.oneClickFromCrmStatus = OneClickFromCrmStatus.CANCELLED
    }
    if (state.oneClickFromContext) {
      state.oneClickFromContext = false
      state.extraParams.fill_from_context = false
    }
    state.actionTakerName = null
  },

  hideActionFormModal(state) {
    state.showingActionFormModal = false
  },

  setCrmSubscribed(state) {
    state.globalSubscriptionCheck.isSubscribed = true
  },

  setShowDaisyChain(state, showDaisyChain) {
    state.showDaisyChain = showDaisyChain
  },

  setAdditionalFieldValue(state, {field, value}) {
    state.action.additionalFields[field] = value
  },

  setEmailOptInValues(state, { value }) {
    state.action.emailOptInTypeId = value.emailOptInTypeId
    state.action.joinOrganisation = value.joinOrganisation
  },

  setFieldValue(state, {field, value}) {
    state.action[field] = value
  },

  setGlobalSubscriptionCheckFromCrmFailed(state) {
    state.globalSubscriptionCheck.crmLookupFailed = true
  },

  setSmsOptInValues(state, {value}) {
    state.action.smsOptInTypeId = value.smsOptInTypeId
    state.action.optInSms = value.optInSms
  },

  setToastErrorMessage(state, message) {
    state.toastErrorMessage = message
    setTimeout(() => {
      state.toastErrorMessage = null
    }, 5000)
  },

  setWindowWidth(state, newWidth) {
    state.windowWidth = newWidth
  },

  showActionFormModal(state) {
    state.showingActionFormModal = true
  }
}
